import state from './moduleMyPeppolSubmissionsState.js'
import mutations from './moduleMyPeppolSubmissionsMutation.js'
import actions from './moduleMyPeppolSubmissionsActions.js'
import getters from './moduleMyPeppolSubmissionsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
